module.exports = __webpack_public_path__ + "img/tuijianchapin.9e6484e0.png";